import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box
} from '@mui/material';
import { useAuth } from '../context/AuthContext';
import AdminDashboard from '../components/AdminDashboard';
import MemberDashboard from '../components/MemberDashboard';
import TrainerDashboard from '../components/TrainerDashboard';
import ReceptionistDashboard from '../components/ReceptionistDashboard';

const DashboardPage = () => {
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect unverified members to registration status page
    if (user && user.role === 'member' && user.registrationStatus !== 'active') {
      navigate('/registration-status');
    }
  }, [user, navigate]);


  const renderDashboard = () => {
    switch (user?.role) {
      case 'admin':
        return <AdminDashboard />;
      case 'trainer':
        return <TrainerDashboard />;
      case 'receptionist':
        return <ReceptionistDashboard />;
      default:
        return <MemberDashboard />;
    }
  };

  return (
    <Box sx={{ width: '100%' }}>
      {renderDashboard()}
    </Box>
  );
};

export default DashboardPage;